import { ToastContextDispatch } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import MyBatchFilter from "Pages/MyBatches/MyBatch/MyBatchFilter";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  GET_BATCHPL_STATUS,
  GET_BATCH_DETAILS,
  GET_BATCH_STUDENT_DETAILS,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import "./index.css";
import MyBatchStudentDetail from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailTab";
import MyBatchDetailsTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchDetailsTab";
import MyBatchTestsTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchTestsTab";
import MyBatchSyllabusTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchSyllabusTab";
import MyBatchLecturesTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchLecturesTab";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import {
  addDays,
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
} from "date-fns";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
import { Badge, Button, Space, Tabs } from "antd";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import styled from "styled-components";
import CourseSubjectListing from "Pages/MyBatches/MyBatch/SharedComponents/CourseSubjectListing";
import ChipsTagsAntdComponent from "utilFunctions/shared/AntdSharedComponents/ChipsTagsAntdComponent";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import { FilterFilled } from "@ant-design/icons";
import { COLORS } from "utilFunctions/Constants/Constants";
import CrossIcon from "Assets/Icons/CrossIcon";
const CustomFilterFilled = styled<any>(FilterFilled)`
  color: ${COLORS.primary};
`;
const CustomTabs = styled<any>(Tabs)`
  .ant-tabs-nav {
    margin: 0px !important;
    margin-top: 16px !important;
    background: white;
    border-radius: 8px;
    padding-left: 12px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #1677ff !important;
    font-weight: 600 !important;
  }
  .ant-tabs-tab-btn {
    font-size: 14px !important;
    // font-weight: 600 !important;
  }
`;
const MainDiv = styled<any>("div")`
  padding-left: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "44px" : "0px"};
  padding-right: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
`;
const SORT_ASC = "ASC";
const BranchStudentTableHeading = [
  { label: "Student Name", value: "studentName" },
  { label: "PSID", value: "psid" },
  { label: "Class Attendance", value: "classAttended" },
  { label: "Tests Attempted", value: "testCount" },
  { label: "Risk Segment | LOP%", value: "riskSegment" },
  { label: "Status", value: "status" },
  { label: "Followups", value: "followUpCounts" },
];

const MyBatchTestsHeading = [
  { label: "Test Name", value: "type" },
  { label: "Start Date-End Date", value: "startDate" },
  { label: "Format | Mode", value: "format" },
  { label: "Result Date", value: "resultDate" },
  { label: "Syllabus Status", value: "testSyllabusStatus" },
];

function MyBatchMain() {
  const navigate = useNavigate();
  const [batchDetailsData, setbatchDetailsData] = useState<any>(null);
  const { screen }: any = useWindowSize();
  const { masters } = useMasterContext();
  const location = useLocation();
  const { state } = location;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [testDetailsFilter, setTestDetailsFilter] = useState<any>("");
  const [filterState, setFilterState] = useState<any>({
    segment: null,
    status: null,
    clazz: null,
    subjectList: null,
  });
  const [chipShow, setChipShow] = useState<any>({
    chipFieldName: null,
  });
  const [dateRanges, setDateRanges] = useState([
    {
      startDate: new Date(
        format(
          setSeconds(setMinutes(setHours(subDays(new Date(), 15), 18), 30), 0),
          "yyyy-MM-dd"
        )
      ),
      endDate: new Date(
        format(
          setSeconds(setMinutes(setHours(addDays(new Date(), 0), 0), 30), 0),
          "yyyy-MM-dd"
        )
      ),
      key: "selection",
    },
  ]);
  const [testSyllabusStatus, setTestSyllabusStatus] = useState<any>([]);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const [selectedCourseSyllabus, setSelectedCourseSyllabus] =
    useState<any>(null);
  const [MyBatchData, setMyBatchData] = useState<any>([]);
  const [batchDetailById, setBatchDetailById] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [sortColumn, setSortColumn] = useState<any>("student_name");
  const [batchId, setBatchId] = useState<string>("");
  const [subjectsList, setSubjectsList] = useState<selectInterface[]>([]);
  const [refresh, setRefresh] = useState<any>(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const { makeRequest: GetMyBatchData, loading: tableloading } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setMyBatchData(data["data"] || []);
        setPagination({ ...pagination, total: data.totalCount });
      } else {
        setMyBatchData([]);
      }
    },
    (error: any) => {
      setMyBatchData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const { makeRequest: GetBatchDetailByBatchID } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setBatchDetailById(data["data"] || []);
        const newSubjectdata: any = [];
        data["data"].map((item: any) => {
          newSubjectdata.push({
            label: item.subj,
            value: item.subj,
            key: item.subj,
            courseId: item.courseId,
          });
        });
        setSubjectsList(newSubjectdata);
        setSelectedCourseSyllabus(data["data"][0]);
      } else {
        setBatchDetailById([]);
      }
    },
    (error: any) => {
      setBatchDetailById([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const { makeRequest: GetBranchDetailsData } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        setbatchDetailsData(data["data"]);
        if (pagination) {
          setLimit(pagination?.pageSize);
        }
        const offset = (pagination.current - 1) * pagination.pageSize;
        const batchId =
          location.pathname.split("/")[
            location.pathname.split("/").length - 1
          ] || "";
        const url = `${BASE_URL}${GET_BATCH_STUDENT_DETAILS}?stream=${data["data"]["academicGroup"]}&batchId=${batchId}&sortBy=studentName&sortDir=ASC`;
        GetMyBatchData(
          `${url}
    &offset=${offset}&limit=${pagination?.pageSize}&`
        );
      } else {
        setbatchDetailsData(null);
      }
    },
    (error) => {
      setbatchDetailsData(null);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const setRedirectPath = (location: any) => {
    if (location && location.state && location.state.myBatchRedirectSelect) {
      const myBatchRedirectSelect = location.state.myBatchRedirectSelect;
      const key = items.find(
        (ele: any) => ele.label == myBatchRedirectSelect
      )?.key;
      setSelectedTabIndex(key);
    }
  };
  useEffect(() => {
    setRedirectPath(location);
    const batchId =
      location.pathname.split("/")[location.pathname.split("/").length - 1] ||
      "";
    if (batchId) {
      const batchUrl = `${BASE_URL}${GET_BATCH_DETAILS}?batchId=${batchId}`;
      GetBranchDetailsData(batchUrl);
      GetBatchDetailByBatchID(BASE_URL + GET_BATCHPL_STATUS + "/" + batchId);
      setBatchId(batchId);
      if (state && state.myBatchRedirectTab) {
        setActiveTab(state.myBatchRedirectTab);
      }
    }
  }, [pagination.pageSize, pagination.current]);

  const isChecked = false;
  const applyFilter = (filterStateObj: any) => {
    setChipShow(filterStateObj);
    if (["Lectures"].includes(selectedTab.label)) {
      setRefresh(new Date().getMilliseconds());
      return;
    }
    if (["Tests"].includes(selectedTab.label)) {
      if (filterStateObj?.testTypes) {
        setTestDetailsFilter(filterStateObj?.testTypes);
      } else {
        setTestDetailsFilter("");
      }
    }
  };
  const items: any["items"] = [
    {
      key: "1",
      name: "Student Details",
      label: "Student Details",
      value: "studentDetails",
      filterListing: [],
      children: (
        <MyBatchStudentDetail
          data={MyBatchData}
          tableHeading={BranchStudentTableHeading}
          loader={tableloading}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          screen={screen}
          pagination={pagination}
          setPagination={setPagination}
        />
      ),
    },
    {
      key: "2",
      name: "Syllabus",
      label: "Syllabus",
      value: "syllabus",
      filterListing: ["CourseSubject"],
      children: (
        <MyBatchSyllabusTab
          screen={screen}
          selectedCourseSyllabus={selectedCourseSyllabus}
          setSelectedCourseSyllabus={setSelectedCourseSyllabus}
          item={batchDetailById}
          batchDetailsData={batchDetailsData}
          batchId={batchId}
        ></MyBatchSyllabusTab>
      ),
    },
    {
      key: "3",
      name: "Lectures",
      label: "Lectures",
      value: "lectures",
      filterListing: ["status", "subject", "date"],
      children: (
        <MyBatchLecturesTab
          selectedCourseSyllabus={selectedCourseSyllabus}
          batchDetailsData={batchDetailsData}
          screen={screen}
          filterState={filterState}
          refresh={refresh}
          setRefresh={setRefresh}
          batchId={batchId}
          dateRanges={dateRanges}
          batchDetailById={batchDetailById}
          setFilterState={setFilterState}
          applyFilter={applyFilter}
          subjects={subjectsList}
          filterListing={["status", "subjectList", "date"]}
        ></MyBatchLecturesTab>
      ),
    },
    {
      key: "4",
      name: "Tests",
      label: "Past Tests",
      value: "Tests",
      children: (
        <MyBatchTestsTab
          tableHeading={MyBatchTestsHeading}
          tableloading={tableloading}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          screen={screen}
          testSyllabusStatus={testSyllabusStatus}
          setTestSyllabusStatus={setTestSyllabusStatus}
          testDetailsFilter={testDetailsFilter}
          batchId={batchId}
          batchDetailById={batchDetailById}
          testTypes={masters.testTypes}
          filterListing={["testTypes"]}
          setFilterState={setFilterState}
          batchDetailsData={batchDetailsData}
          showPastTest={true}
        ></MyBatchTestsTab>
      ),
    },
    {
      key: "5",
      name: "Tests",
      label: "Upcoming Tests",
      value: "Tests",
      children: (
        <MyBatchTestsTab
          tableHeading={MyBatchTestsHeading}
          tableloading={tableloading}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          setSortColumn={setSortColumn}
          setSortOrder={setSortOrder}
          screen={screen}
          testSyllabusStatus={testSyllabusStatus}
          setTestSyllabusStatus={setTestSyllabusStatus}
          testDetailsFilter={testDetailsFilter}
          batchId={batchId}
          batchDetailById={batchDetailById}
          testTypes={masters.testTypes}
          filterListing={["testTypes"]}
          setFilterState={setFilterState}
          batchDetailsData={batchDetailsData}
          showPastTest={false}
        ></MyBatchTestsTab>
      ),
    },
    {
      key: "6",
      name: "Batch Details",
      label: "Batch Details",
      value: "basicDetails",
      filterListing: [],
      children: (
        <MyBatchDetailsTab
          screen={screen}
          state={state}
          batchDetailsData={batchDetailsData}
        ></MyBatchDetailsTab>
      ),
    },
  ];
  const handleClearAllFilter = () => {
    const clearedFilter = {
      stream: null,
      clazz: null,
      segment: null,
      status: null,
      subjectList: null,
    };
    setFilterState(clearedFilter);
    clearShowChipHandler();
    if (["Lectures"].includes(selectedTab.label)) {
      setDateRanges([
        {
          startDate: new Date(
            format(
              setSeconds(
                setMinutes(setHours(subDays(new Date(), 15), 18), 30),
                0
              ),
              "yyyy-MM-dd HH:mm:ss"
            )
          ),
          endDate: new Date(
            format(
              setSeconds(
                setMinutes(setHours(addDays(new Date(), 0), 18), 30),
                0
              ),
              "yyyy-MM-dd HH:mm:ss"
            )
          ),
          key: "selection",
        },
      ]);
      setRefresh(new Date().getMilliseconds());
      return;
    }
    resetHandler && resetHandler();
  };
  const clearShowChipHandler = () => {
    setChipShow({
      chipFieldName: null,
    });
  };
  const newFilterState = JSON.parse(JSON.stringify(chipShow));
  // delete newFilterState.startDate;
  delete newFilterState.endDate;
  const chipsFields = newFilterState.chipFieldName;
  if (chipsFields && chipsFields.startDate) {
    chipsFields.startDate = chipsFields.startDate + " ~ " + chipsFields.endDate;
    delete chipsFields.endDate;
  }
  delete newFilterState.chipFieldName;
  const filterLength = Object.values(newFilterState).filter(
    (ele) => ele != null
  ).length;
  const selectedTab = items.find((ele: any) => ele.key === selectedTabIndex);

  const resetHandler = () => {
    if (activeTab === 0) {
      const url = `${BASE_URL}${GET_BATCH_STUDENT_DETAILS}?stream=${batchDetailsData["academicGroup"]}&batchId=${state.batch.batchId}&sortBy=studentName&sortDir=ASC`;
      GetMyBatchData(
        `${url}
          &offset=${0}&limit=${limit}&`
      );
    }
    setDateRanges([
      {
        startDate: new Date(
          format(
            setSeconds(
              setMinutes(setHours(subDays(new Date(), 15), 18), 30),
              0
            ),
            "yyyy-MM-dd"
          )
        ),
        endDate: new Date(
          format(
            setSeconds(setMinutes(setHours(addDays(new Date(), 0), 0), 30), 0),
            "yyyy-MM-dd"
          )
        ),
        key: "selection",
      },
    ]);
    setFilterState({
      segment: null,
      status: null,
      testTypes: null,
    });
    if (["Tests"].includes(selectedTab.label)) {
      console.log("filters cleared");
      setTestDetailsFilter("");
    }
  };
  const Reset = ({ isFullScreen }: any) => {
    return (
      <>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <Button onClick={handleClearAllFilter}>Reset</Button>
        ) : (
          <>
            {isFullScreen ? (
              <Button onClick={handleClearAllFilter}>Reset</Button>
            ) : (
              <CrossIcon onClick={handleClearAllFilter}></CrossIcon>
            )}
          </>
        )}
      </>
    );
  };
  const FilterBtn = () => (
    <Badge
      count={filterLength}
      size={["xxl", "xl", "lg"].includes(screen) ? "default" : "small"}
    >
      <>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <Button
            size={["xxl", "xl", "lg"].includes(screen) ? "middle" : "small"}
            type="primary"
            onClick={() => {
              setIsDrawerOpen(true);
            }}
          >
            Filters
          </Button>
        ) : (
          <CustomFilterFilled
            onClick={() => {
              setIsDrawerOpen(true);
            }}
          />
        )}
      </>
    </Badge>
  );
  const onCloseHandler = (value: any) => {
    const newFilterState = JSON.parse(JSON.stringify(filterState));
    newFilterState[value] = null;
    applyFilter(newFilterState);
    setFilterState({
      ...filterState,
      [value]: null,
    });
  };
  console.log(newFilterState, "onChipsandytag", chipsFields);
  const HeaderCM = () => (
    <HeadersComponent
      cardTitle={`${batchDetailsData?.batchName} | ${batchDetailsData?.academicGroup}`}
      backButtonHandler={(e: any) => {
        e.preventDefault();
        navigate(-1);
      }}
    >
      <div className="d-flex align-items-center">
        {filterLength != 0 && ["xxl", "xl", "lg"].includes(screen) && (
          <ChipsTagsAntdComponent
            filterState={removeEmptyFields(newFilterState)}
            chipsFields={chipsFields}
            onCloseHandler={onCloseHandler}
          ></ChipsTagsAntdComponent>
        )}
        {selectedTab?.filterListing && selectedTab?.filterListing.length ? (
          <Space>
            {selectedTab.label != "Syllabus" ? (
              <FilterBtn />
            ) : (
              <>
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <CourseSubjectListing
                    item={batchDetailById}
                    selectedCourseSyllabus={selectedCourseSyllabus}
                    selectedCourseSyllabusHandler={setSelectedCourseSyllabus}
                  ></CourseSubjectListing>
                ) : (
                  <FilterBtn />
                )}
              </>
            )}
            {filterLength != 0 && <Reset isFullScreen={false} />}
          </Space>
        ) : null}
      </div>
    </HeadersComponent>
  );
  const onChange = (key: string) => {
    setSelectedTabIndex(key);
    clearAllStatesHandler();
  };
  const clearAllStatesHandler = () => {
    setFilterState({
      segment: null,
      status: null,
      testTypes: null,
    });
  };
  useEffect(() => {
    setFilterState({
      segment: null,
      status: null,
      testTypes: null,
    });
    setChipShow({
      chipFieldName: null,
    });
  }, [selectedTabIndex]);
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={isDrawerOpen}
        setOpen={setIsDrawerOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-end">
              {selectedTab.label != "Syllabus" && (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      applyFilter(filterState);
                      setIsDrawerOpen(false);
                    }}
                    className="m-0"
                  >
                    Apply
                  </Button>
                  <Reset isFullScreen={true} />
                </>
              )}
              <Button onClick={() => setIsDrawerOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <MyBatchFilter
          filterState={filterState}
          setFilterState={setFilterState}
          applyFilter={applyFilter}
          resetHandler={resetHandler}
          location={location}
          subjects={subjectsList}
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
          open={open}
          setOpen={setOpen}
          selectedTab={selectedTab}
          state={state}
          batchDetailsData={batchDetailsData}
          isChecked={isChecked}
          activeTab={activeTab}
          batchDetailById={batchDetailById}
          selectedCourseSyllabus={selectedCourseSyllabus}
          setRefresh={setRefresh}
          refresh={refresh}
          setSelectedCourseSyllabus={(val: any) => {
            setSelectedCourseSyllabus(val);
            setIsDrawerOpen(false);
          }}
          setChipShow={setChipShow}
        />
      </DrawerAntdComponent>
      <MainDiv screen={screen}>
        <HeaderCM />
        <CustomTabs
          activeKey={selectedTabIndex}
          defaultActiveKey={selectedTabIndex}
          items={items}
          onChange={onChange}
          destroyInactiveTabPane={true}
        />
      </MainDiv>
    </>
  );
}

export default MyBatchMain;
